import {
	ASSIGNEE_TYPE,
	NUMBER_CF_TYPE,
	NUMBER_GQL_FIELD,
	PRIORITY_GQL_FIELD,
	PRIORITY_TYPE,
	REPORTER_TYPE,
	RICH_TEXT_GQL_FIELD,
	STORY_POINT_ESTIMATE_CF_TYPE,
	TEXT_AREA_CF_TYPE,
	USER_PICKER_GQL_FIELD,
	DATE_PICKER_GQL_FIELD,
	DATE_CF_TYPE,
	TEXT_GQL_FIELD,
	TEXT_CF_TYPE,
	SPRINT_GQL_FIELD,
	SPRINT_TYPE,
	CASCADING_SELECT_GQL_FIELD,
	CASCADING_SELECT_CF_TYPE,
	CHECKBOX_GQL_FIELD,
	MULTI_CHECKBOXES_CF_TYPE,
	MULTI_SELECT_GQL_FIELD,
	MULTI_SELECT_CF_TYPE,
	MULTI_USER_PICKER_GQL_FIELD,
	MULTI_USER_CF_TYPE,
	RADIO_GQL_FIELD,
	RADIO_BUTTONS_CF_TYPE,
	URL_GQL_FIELD,
	URL_CF_TYPE,
	SINGLE_GROUP_PICKER_GQL_FIELD,
	ISSUE_FIELD_SINGLE_GROUP_CF_TYPE,
	MULTI_GROUP_PICKER_GQL_FIELD,
	MULTI_GROUP_CF_TYPE,
	MULTI_VERSION_GQL_FIELD,
	FIX_VERSIONS_TYPE,
	AFFECTS_VERSIONS_TYPE,
	PROJECT_GQL_FIELD,
	ISSUE_FIELD_PROJECT_CF_TYPE,
	PROJECT_PICKER_CF_TYPE,
	COLOR_GQL_FIELD,
	COLOR_CF_TYPE,
	EPIC_COLOR_TYPE,
	COLOR_TYPE,
	ENVIRONMENT_TYPE,
	VERSION_GQL_FIELD,
	ISSUE_FIELD_VERSION_CF_TYPE,
	VERSION_CF_TYPE,
	SECURITY_GQL_FIELD,
	SECURITY_LEVEL_TYPE,
	SECURITY_LEVEL_TYPE_OVERRIDE,
	LABEL_GQL_FIELD,
	LABELS_TYPE,
	LABELS_CF_TYPE,
	COMMENT_TYPE,
	GROUP_CF_TYPE,
	DUE_DATE_TYPE,
	BASELINE_START_CF_TYPE,
	BASELINE_END_CF_TYPE,
	DATE_TIME_GQL_FIELD,
	DATETIME_CF_TYPE,
	SINGLE_SELECT_GQL_FIELD,
	SELECT_CF_TYPE,
	USER_CF_TYPE,
	MULTI_VERSION_CF_TYPE,
	PARENT_GQL_FIELD,
	PARENT_TYPE,
	ATLASSIAN_TEAM_GQL_FIELD,
	TEAMS_PLATFORM_CF_TYPE,
	COMPONENTS_GQL_FIELD,
	COMPONENTS_TYPE,
	DURATION_GQL_FIELD,
	TIME_ESTIMATE_TYPE,
	TIME_TRACKING_GQL_FIELD,
	TIME_TRACKING_TYPE,
} from '@atlassian/jira-platform-field-config';

export const CONTEXTUAL_BULK_EDIT_ISSUE_LIMIT = 50; // backlog contextual menu still depends on this constant
export const BULK_EDIT_SELECTED_ISSUE_LIMIT = 1000;

// TODO: delete getBulkEditFieldList on bulk-transitions-third-iteration_ecc9c cleanup
export const getBulkEditFieldList = (): Record<string, string[]> => ({
	[ATLASSIAN_TEAM_GQL_FIELD]: [TEAMS_PLATFORM_CF_TYPE],
	[CASCADING_SELECT_GQL_FIELD]: [CASCADING_SELECT_CF_TYPE],
	[CHECKBOX_GQL_FIELD]: [MULTI_CHECKBOXES_CF_TYPE],
	[COLOR_GQL_FIELD]: [COLOR_CF_TYPE, EPIC_COLOR_TYPE, COLOR_TYPE],
	[DATE_PICKER_GQL_FIELD]: [
		DATE_CF_TYPE,
		DUE_DATE_TYPE,
		BASELINE_START_CF_TYPE,
		BASELINE_END_CF_TYPE,
	],
	[DATE_TIME_GQL_FIELD]: [DATETIME_CF_TYPE],
	[LABEL_GQL_FIELD]: [LABELS_TYPE, LABELS_CF_TYPE],
	[MULTI_GROUP_PICKER_GQL_FIELD]: [MULTI_GROUP_CF_TYPE],
	[MULTI_SELECT_GQL_FIELD]: [MULTI_SELECT_CF_TYPE],
	[MULTI_USER_PICKER_GQL_FIELD]: [MULTI_USER_CF_TYPE],
	[MULTI_VERSION_GQL_FIELD]: [FIX_VERSIONS_TYPE, AFFECTS_VERSIONS_TYPE, MULTI_VERSION_CF_TYPE],
	[NUMBER_GQL_FIELD]: [NUMBER_CF_TYPE, STORY_POINT_ESTIMATE_CF_TYPE],
	[PARENT_GQL_FIELD]: [PARENT_TYPE],
	[COMPONENTS_GQL_FIELD]: [COMPONENTS_TYPE],
	[PRIORITY_GQL_FIELD]: [PRIORITY_TYPE],
	[PROJECT_GQL_FIELD]: [ISSUE_FIELD_PROJECT_CF_TYPE, PROJECT_PICKER_CF_TYPE],
	[RADIO_GQL_FIELD]: [RADIO_BUTTONS_CF_TYPE],
	[RICH_TEXT_GQL_FIELD]: [TEXT_AREA_CF_TYPE, ENVIRONMENT_TYPE, COMMENT_TYPE],
	[SECURITY_GQL_FIELD]: [SECURITY_LEVEL_TYPE, SECURITY_LEVEL_TYPE_OVERRIDE],
	[SINGLE_GROUP_PICKER_GQL_FIELD]: [ISSUE_FIELD_SINGLE_GROUP_CF_TYPE, GROUP_CF_TYPE],
	[SINGLE_SELECT_GQL_FIELD]: [SELECT_CF_TYPE],
	[SPRINT_GQL_FIELD]: [SPRINT_TYPE],
	[TEXT_GQL_FIELD]: [TEXT_CF_TYPE],
	[URL_GQL_FIELD]: [URL_CF_TYPE],
	[USER_PICKER_GQL_FIELD]: [ASSIGNEE_TYPE, REPORTER_TYPE, USER_CF_TYPE],
	[VERSION_GQL_FIELD]: [ISSUE_FIELD_VERSION_CF_TYPE, VERSION_CF_TYPE],
	[DURATION_GQL_FIELD]: [TIME_ESTIMATE_TYPE],
	[TIME_TRACKING_GQL_FIELD]: [TIME_TRACKING_TYPE],
});

/* section TESTIDs */
export const FORM_WRAPPER_TEST_ID = 'bulk-operations-core.ui.form.form-wrapper';
export const FOOTER_CANCEL_BUTTON_TEST_ID =
	'bulk-operations-core.common.ui.view-footer.cancel-button';
export const FOOTER_BACK_BUTTON_TEST_ID = 'bulk-operations-core.common.ui.view-footer.back-button';
export const FOOTER_NEXT_BUTTON_TEST_ID = 'bulk-operations-core.common.ui.view-footer.next-button';
export const EDIT_FIELDS_TEST_ID = 'bulk-operations-core.ui.toolbar.edit-dropdown.menu.edit-fields';
export const EDIT_STATUS_TEST_ID = 'bulk-operations-core.ui.toolbar.edit-dropdown.menu.edit-status';

/* Field Search */
export const FIELD_SEARCH_OPTION_HEIGHT = 40;
export const FIELD_SEARCH_OPTION_WITH_FIELD_TYPE_HEIGHT = 50;
